import ApiService from "../../../services/api";
import moment from "moment";
import helpers from "../../../shared/fleetbox-helpers";

export default {
	props: {
		data: Array
	},
	data: function() {
		return {
			//#region Charts
			/* Fleet Status */
			pdfOptions: {
				landscape: true,
				fileName: "Stato dei veicoli",
				title: "Stato dei veicoli"
			},
			legend: {
				position: "bottom",
				item: {
					visual: function(e) {
						var color = e.series.data[e.pointIndex].color; //e.options.markers.background;
						var labelColor = e.options.labels.color;
						var rect = new kendo.geometry.Rect([0, 0], [200, 50]);
						var layout = new kendo.drawing.Layout(rect, {
							spacing: 5,
							alignItems: "center"
						});

						var marker = new kendo.drawing.Path({
							fill: {
								color: color
							},
							stroke: {
								color: color
							}
						})
							.moveTo(0, 0)
							.lineTo(0, 10)
							.lineTo(30, 10)
							.lineTo(30, 0)
							.close();

						var label = new kendo.drawing.Text(e.series.data[e.pointIndex].category, [0, 0], {
							fill: {
								color: labelColor
							},
							font: "13px 'Montserrat Light', montserrat-light !important"
						});

						var rectGeom = new kendo.geometry.Rect([0, 0], [50, 10]);
						var rectangle = new kendo.drawing.Rect(rectGeom, {
							fill: { color: "none" },
							stroke: { color: "none" }
						});

						layout.append(marker, label, rectangle);
						layout.reflow();

						return layout;
					}
				}
			},
			fleetChartArea: {
				background: "#ffffff"
			},
			fleetStatus: [
				{
					name: "Stato dei Mezzi",
					field: "value",
					labels: {
						visible: true,
						background: "transparent",
						position: "outsideEnd",
						template: "#= category #: #= value #",
						format: "n0",
						font: "10px montserrat-light"
					},
					padding: 40
				}
			],
			fleetStatusData: [],
			fleetStatusTooltip: {
				visible: true,
				template: "#= category # - #= value #"
			},
			fleetStatusModal: false,
			fleetStatusModalIndex: 0,
			modalTitle: "Stato dei veicoli",
			loading: true
			/* Fleet Status */
			//#endregion
		};
	},

	created() {
		//this.getFleetStatus();
	},
	watch: {
		data: function(newData) {
			let statusData = {};
			var self = this;

			for (var i = 0; i < newData.length; i++) {
				let st = newData[i];

				if (statusData[st.status]) {
					statusData[st.status] += 1;
					continue;
				} 

				statusData[st.status] = 1;
			}

			let statusDataPlain = [];

			for (var j = 0; j < Object.keys(statusData).length; j++) {
				let key = Object.keys(statusData)[j];

				statusDataPlain.push({
					key: key,
					count: statusData[key]
				});
			}
			
			self.fleetStatusData = statusDataPlain.map(function(item) {
				return self.getUserFriendlyFleetStatusData(item);
			});

			setTimeout(function() {
				self.loading = false;
			}, 200);
		}
	},
	methods: {
		/* Fleet Status */
		getFleetStatus() {
			var self = this;
			ApiService.getFleetStatus().then(res => {
				self.fleetStatusData = res.map(function(item) {
					return self.getUserFriendlyFleetStatusData(item);
				});

				setTimeout(function() {
					self.loading = false;
				}, 200);
			});
		},

		getUserFriendlyFleetStatusData(dataItem) {
			if (dataItem) {
				var fleetState = "MOVIMENTO";
				var colorState = "#26958f";
				switch (dataItem.key) {
					case "off":
						fleetState = "FERMI";
						colorState = "#d34333";
						break;

					case "stop":
						fleetState = "INATTIVI";
						colorState = "#f19926";
						break;
				}

				return {
					category: fleetState,
					value: dataItem.count,
					color: colorState
				};
			}
		},

		fleetStatusClickHandler(e) {
			this.fleetStatusModal = true;
			$(".k-tooltip.k-chart-tooltip").remove();
			setTimeout(() => {
				this.fleetStatusModalIndex++;
			}, 200);
		},

		exportAsPdf() {
			// var chart = this.$refs.chartFleetStatusModal.kendoWidget();
			// chart.saveAsPDF();

			var container = $("<div />")
				.css({
					position: "absolute",
					top: 0,
					left: -1000,
					height: 800
				})
				.appendTo("body");

			function cleanup() {
				container.getKendoChart().destroy();
				container.remove();
			}

			this.createChart(container, {
				// Custom settings for export
				transitions: false,

				// Cleanup
				render: function(e) {
					e.sender.saveAsPDF();
					setTimeout(cleanup, 500);
				}
			});
		},
		createChart(container, exportOptions) {
			var self = this;

			var now = moment();
			var pdfTitle = `Stato dei veicoli del ${self.$options.filters.datetimeToString(now)}`;
			self.pdfOptions.fileName = `Stato_veicoli_${self.$options.filters.datetimeToStringDot(now)}.pdf`;

			var options = {
				pdf: self.pdfOptions,
				theme: "metro",
				title: {
					text: pdfTitle.toUpperCase(),
					font: "bold 20px montserrat-bold"
				},
				legend: {
					visible: true,
					position: "bottom",
					item: {
						visual: function(e) {
							var color = e.series.data[e.pointIndex].color; //e.options.markers.background;
							var labelColor = e.options.labels.color;
							var rect = new kendo.geometry.Rect([0, 0], [200, 200]);
							var layout = new kendo.drawing.Layout(rect, {
								spacing: 5,
								alignItems: "center"
							});

							var marker = new kendo.drawing.Path({
								fill: {
									color: color
								},
								stroke: {
									color: color
								}
							})
								.moveTo(0, 0)
								.lineTo(0, 10)
								.lineTo(30, 10)
								.lineTo(30, 0)
								.close();

							var label = new kendo.drawing.Text(e.series.data[e.pointIndex].category, [0, 0], {
								fill: {
									color: labelColor
								},
								font: "13px 'Montserrat Light', montserrat-light"
							});

							var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
							var rectangle = new kendo.drawing.Rect(rectGeom, {
								fill: { color: "none" },
								stroke: { color: "none" }
							});

							layout.append(marker, label, rectangle);
							layout.reflow();

							return layout;
						}
					}
				},
				seriesDefaults: {
					type: "donut",
					labels: {
						visible: true
					},
					startAngle: 150
				},
				dataSource: {
					data: self.fleetStatusData
				},
				series: [
					{
						name: "Stato dei Mezzi",
						field: "value",
						labels: {
							visible: true,
							background: "transparent",
							position: "outsideEnd",
							template: "#= category #: #= value #",
							font: "13px montserrat-light",
							format: "n2"
						}
					}
				]
			};

			options = $.extend(true, options, exportOptions);
			container.kendoChart(options);
		},
		exportAsXlsx(type) {
			var self = this;
			ApiService.exportAnalyticsXlsx("status", type).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Stato della flotta.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		}
		/* Fleet Status */
	}
};
